import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login, admin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin && admin !== false) navigate("/admin");
  }, [admin]); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin!");
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center dark-luxury px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="text-center">
          <div className="mx-auto h-14 w-14 rounded-full bg-[#FEF3C7] grid place-items-center text-[#9A3412]"><Lock size={24} /></div>
          <h1 className="font-display text-2xl font-bold text-[#1F130B] mt-4">Admin Login</h1>
          <p className="text-sm text-[#6B5B52] mt-1">Sonia Dry Fruits Jammu</p>
        </div>
        <div className="mt-6 space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-email" className="w-full rounded-xl border border-[#E7E0D6] bg-[#FAF6F0] px-4 py-3 text-sm outline-none focus:border-[#C2410C]" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-password" className="w-full rounded-xl border border-[#E7E0D6] bg-[#FAF6F0] px-4 py-3 text-sm outline-none focus:border-[#C2410C]" />
          <button disabled={loading} data-testid="admin-login-btn" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C2410C] hover:bg-[#9A3412] text-white font-semibold py-3 disabled:opacity-70">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Login"}
          </button>
        </div>
      </form>
    </div>
  );
}
